import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// Hero posters
import mouleeshwaranImg from "../../assets/hero/mouleeshwaran.png";
import sabareeshwaranImg from "../../assets/hero/sabareeshwaran.png";
import rakeshImg from "../../assets/hero/image2.jpg";
import kiranImg from "../../assets/hero/image1.jpg";

const Hero = () => {
  const images = [
    mouleeshwaranImg,
    sabareeshwaranImg,
    rakeshImg,
    kiranImg,
  ];

  return (
    <section className="w-full bg-[#1a1a1a]">
      <Swiper
        style={{
          "--swiper-navigation-color": "#ffffff",
          "--swiper-pagination-color": "#ffffff",
          "--swiper-navigation-size": "30px",
        }}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        loop={true}
        className="w-full h-auto md:h-screen drop-shadow-md"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="w-full h-full flex justify-center items-center overflow-hidden">
              <img
                src={img}
                alt={`Hero Poster ${index + 1}`}
                className="w-full h-[50vh] md:h-full object-contain md:object-cover"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Hero;
